import { Component, createRef, h, Ref, RefObject, render } from "preact";
import { useEffect, useState } from "preact/hooks";
import { CParser, CParserData, CParserError } from "./CParser";
import { predefinedCode } from "./PredefinedCode";

window.addEventListener("load", () => {
    render(<App/>, document.getElementById("app")!);
});

function App() {
    const [hexBytes, setHexBytes] = useState("");
    const [code, setCode] = useState("");
    const [result, setResult] = useState("");
    const [parsedCode, setParsedCode] = useState(null as CParserData | null);
    const [error, setError] = useState("");
    const [selectedType, setSelectedType] = useState("");

    useEffect(() => {
        const url = new URL(location.href);

        if (url.searchParams.has("bytes")) {
            setHexBytes(url.searchParams.get("bytes")!);
        }

        if (url.searchParams.has("type")) {
            const type = url.searchParams.get("type")!;
            if (type in predefinedCode) {
                setCode((predefinedCode as any)[type]);
            }

            setSelectedType(type);
        }
    }, [true]);

    useEffect(() => {
        const parser = new CParser();

        setError("");

        try {
            const parsed = parser.parse(code);
            setParsedCode(parsed);
        }
        catch(ex) {
            setParsedCode(null);

            if (ex instanceof CParserError) {
                setError(`${ex}, Line: ${ex.line}, Column: ${ex.column}`);
            }
            else {
                setError(ex.toString());
            }
        }
    }, [code]);

    useEffect(() => {
        if (!parsedCode || !hexBytes || !selectedType) {
            return;
        }

        setError("");

        const hexBytesUnprocessed = hexBytes.replace(/\s+/gm, "");

        if (hexBytesUnprocessed.length % 2 !== 0) {
            setError("Hex bytes length % 2 !== 0");
            return;
        }

        const type = parsedCode.getType(selectedType);

        if (!type) {
            setError(`Type with name ${selectedType} was not found`);
            return;
        }

        if (type.bitSize % 8 !== 0) {
            setError(`Type bit size % 8 !== 0`);
            return;
        }

        const bytes = new Uint8Array(type.bitSize / 8);

        for (let i = 0; i < hexBytesUnprocessed.length / 2; i++) {
            bytes[i] = parseInt(hexBytesUnprocessed[i * 2] + hexBytesUnprocessed[i * 2 + 1], 16);
        }

        const result = parsedCode.getType(selectedType).read(bytes.buffer, 0, 0);
        console.log(result);

        let json = JSON.stringify(result, (key, value) => {
            if (typeof value === "number") {
                return value.toString(16);
            }

            return value;
        }, 4);

        json = json.replace(/"/gm, "");

        setResult(json);
    }, [parsedCode, hexBytes]);

    return <div class="app">
        <div class="accordion" style="width: 100%">
            <div>
                <input type="radio" name="accordion"/>
                <input type="radio" name="accordion"/>
                <div class="header">Text fields</div>
                <div class="content" style="padding: 10px; flex-direction: column; align-items: center;">
                    <div class="inputs">

                        <textarea class="hex-bytes" placeholder="Hex Bytes" value={hexBytes} onChange={(e) => {
                            setHexBytes(e.currentTarget.value);
                        }}/>
                        <textarea class="code" placeholder="C Struct" value={code} onChange={(e) => {
                            const code = e.currentTarget.value;
                            setCode(code);
                        }}/>
                    </div>
                    {error ? <div class="alert error">
                        {error}
                    </div> : null}
                    {parsedCode ? <div>
                        <select value={selectedType} onChange={(e) => setSelectedType(e.currentTarget.value)}>
                            {Object.entries(parsedCode.getTypes()).map(([key, value]) => <option value={key}>
                                {key} - Bytes: {value.bitSize / 8}, Bits: {value.bitSize}
                            </option>)}
                        </select>
                    </div> : null}
                </div>
            </div>
        </div>

        <button onClick={() => {
            navigator.clipboard.writeText(result);
        }}>Copy to clipboard</button>
        <div class="result">{result}</div>
    </div>;
}